import Component from '../core/Component'
import { loadComponents } from '../core/componentUtils'
import { queryAll } from '../utils/dom'

export const STATES = {
    ACTIVE: 'is-active'
}

export default class FormSearch extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            input: null,
            select: null
        }

        this.handleOuterClick = ::this.handleOuterClick
    }

    prepare() {
        this.ref.select.addEventListener('change', ::this.handleSelectChange)
        this.handleSelectChange()
    }

    destroy() {
        document.removeEventListener('click', this.handleOuterClick)
    }

    handleSelectChange() {
        const selected = queryAll('option', this.ref.select)[this.ref.select.selectedIndex]
        let autocomplete = Component.getFromElement(this.ref.input)

        if (selected.dataset.autocomplete) {
            if (!autocomplete) {
                loadComponents(this.element)
                autocomplete = Component.getFromElement(this.ref.input)
            }
            autocomplete.enable(selected.dataset.autocomplete)
        } else {

            if (autocomplete) {
                autocomplete.disable()
            }

        }
    }

    handleOuterClick(event) {
        if (!this.element.contains(event.target)) {
            this.hide()
        }
    }

    show() {
        this.element.classList.add(STATES.ACTIVE)

        document.addEventListener('click', this.handleOuterClick)
    }

    hide() {
        this.element.classList.remove(STATES.ACTIVE)

        document.removeEventListener('click', this.handleOuterClick)
    }

    toggle() {
        if (this.is(STATES.ACTIVE)) {
            this.hide()
        } else {
            this.show()
        }
    }

}